module.exports = "/img/_/_/_/assets/images/icon//legendary.png?eff3706855860031f01a188b9f664b89";